<template>
    <h2 class="d-inline-block" style="position: relative;">
        <div v-if="$router.currentRoute.name == 'mediaCallPage'" class="media-call-icon" :class="!userAbilities.createMediaCall ? 'pointer-default' : ''" @click="userAbilities.createMediaCall ? createMediaCall() : ''">
            <img :src="require(`@/csmworkflow/img/media-call.svg`)"/>
            <span class="add-media-call-icon" >
                <img src="@/csmworkflow/img/add-icon.svg"/>
            </span>
        </div>
        <div v-else class="media-call-icon">
            <img :src="require(`@/csmworkflow/img/${deliverableTemplateIcon}.svg`)"/>
        </div>

        <transition name="deliverableTemplate-buttons-fade">
        <div class="all-deliverableTemplate-buttons" v-if="showAllAddButton && hasMultipleDeliverableTemplate && userAbilities.createMediaCall">
            <div class="media-call-icon" v-for="(type,i) in newDeliverableTemplates" :key="i" @click="createDeliverableTemplate(type)">
                <img :src="require(`@/csmworkflow/img/${type.typeIcon}.svg`)"/>
                <span class="add-media-call-icon" >
                    <img src="@/csmworkflow/img/add-icon.svg"/>
                </span>
            </div>
        </div>
        </transition>

        {{deliverableTemplateTitle}}
        <span class="text-muted below-title" v-if="showDeliverableTemplateCount">{{deliverableTemplateCount}} DeliverableTemplate<span v-if="deliverableTemplateCount !== 1">s</span><span v-if="$router.currentRoute.name != 'socialMedia' && $router.currentRoute.name != 'socialMediaGrouped' && $router.currentRoute.name != 'socialMediaSchedule'">, {{totalOutletCount}} Calls</span></span>
        <span class="text-muted" v-if="showDeliverableTemplateCountMyWeek">
            (
            <a href="#" @click="overdueClick('overdue')"  :style="{backgroundColor: getBgColor('overdue')}" v-if="deliverableTemplateCount['overdue']>0">{{deliverableTemplateCount['overdue']}} overdue</a>
            <a href="#" @click="overdueClick('overdue')"  :style="{backgroundColor: getBgColor('overdue'), pointerEvents:'none', texDecoration: 'none', color: 'var(--wf-secondary-tertiary-mix80)'}" v-else>{{deliverableTemplateCount['overdue']}} overdue</a>,
            <a href="#" @click="overdueClick('today')"  :style="{backgroundColor: getBgColor('today')}" v-if="deliverableTemplateCount['today']>0" >{{deliverableTemplateCount['today']}} today</a>
            <a href="#" @click="overdueClick('today')"  :style="{backgroundColor: getBgColor('today'), pointerEvents:'none', texDecoration: 'none', color: 'var(--wf-secondary-tertiary-mix80)'}" v-else>{{deliverableTemplateCount['today']}} today</a>,
            <a href="#" @click="overdueClick('thisWeek')" :style="{backgroundColor: getBgColor('thisWeek')}" v-if="deliverableTemplateCount['thisWeek']>0"  >{{deliverableTemplateCount['thisWeek']}} this week</a>
            <a href="#" @click="overdueClick('thisWeek')" :style="{backgroundColor: getBgColor('thisWeek'), pointerEvents:'none', texDecoration: 'none', color: 'var(--wf-secondary-tertiary-mix80)'}"  v-else>{{deliverableTemplateCount['thisWeek']}} this week</a>,
            <a href="#" @click="overdueClick('nextWeek')" :style="{backgroundColor: getBgColor('nextWeek')} "  v-if="deliverableTemplateCount['nextWeek']>0">{{deliverableTemplateCount['nextWeek']}} next week</a>
            <a href="#" @click="overdueClick('nextWeek')" :style="{backgroundColor: getBgColor('nextWeek'), pointerEvents:'none', texDecoration: 'none', color: 'var(--wf-secondary-tertiary-mix80)' }"  v-else>{{deliverableTemplateCount['nextWeek']}} next week</a>,
            <a href="#" @click="overdueClick('upcoming')" :style="{backgroundColor: getBgColor('upcoming')}"  v-if="deliverableTemplateCount['upcoming']>0">{{deliverableTemplateCount['upcoming']}} upcoming</a>
            <a href="#" @click="overdueClick('upcoming')" :style="{backgroundColor: getBgColor('upcoming'), pointerEvents:'none', texDecoration: 'none', color: 'var(--wf-secondary-tertiary-mix80)' }"  v-else >{{deliverableTemplateCount['upcoming']}} upcoming</a>,
            <a href="#" @click="overdueClick('noDeadline')"  :style="{backgroundColor: getBgColor('noDeadline')}"   v-if="deliverableTemplateCount['noDeadline']>0">{{deliverableTemplateCount['noDeadline']}} no deadline</a>
            <a href="#" @click="overdueClick('noDeadline')"  :style="{backgroundColor: getBgColor('noDeadline'), pointerEvents:'none', texDecoration: 'none', color: 'var(--wf-secondary-tertiary-mix80)' }"  v-else >{{deliverableTemplateCount['noDeadline']}} no deadline</a>
          )
        </span>
        <!-- <span v-html="title"></span> -->
    </h2>
</template>
<script>
import { mapState, mapActions } from 'vuex';
    export default {
        components: {

        },
        props: {
            totalDeliverableTemplateCount: Number,
            totalDeliverableTemplateCountNoMasters: Number,
            totalOutletCount: Number,
            myWeek: Boolean,
            isListView: Boolean,
            title: String,
            namespace:String
        },
        data() {
            return {
                showAllAddButton: false,
                filterQuery: {},
                pointerEvents:"",
                texDecoration:"",
                textColor:"",
                // weekFilterOptions: {
                //     overdue: false,
                //     today: false,
                //     thisWeek: false,
                //     nextWeek: false,
                //     upcoming: false,
                //     noDeadline: false,
                // }
            };
        },
        computed: {
        	...mapState({
        	  state (state) {
        	    return state[this.namespace]
        	  },
        	  deliverableTemplates (state, getters) {
        	    return getters[this.namespace + 'deliverableTemplates']
        	  },
        	  newDeliverableTemplates (state, getters) {
        	    return getters[this.namespace + 'newDeliverableTemplates']
        	  },
        	  userAbilities (state, getters) {
        	    return getters['userAbilities']
        	  },
        	  deliverableTemplateCount (state, getters) {
        	    return getters[this.namespace + 'deliverableTemplateCount']
        	  },
        	  myWeekDeliverableTemplateFilter (state, getters) {
        	    return getters[this.namespace + 'myWeekDeliverableTemplateFilter']
        	  },
        	  dataLoading (state, getters) {
        	    return getters[this.namespace + 'dataLoading']
        	  },
        	}),
            deliverableTemplateTitle() {
            	return "Edit Deliverable Templates";
            },
            deliverableTemplateIcon() {
            	return "template-editor-icon";
            },

            hasMultipleDeliverableTemplate() {
                if (!this.deliverableTemplates || this.deliverableTemplates.length == 0) {
                    return true;
                }
                return this.deliverableTemplates.length > 1;
            },

            showDeliverableTemplateCount() {
                return this.totalDeliverableTemplateCount != null && this.totalOutletCount != null;
            },
            showDeliverableTemplateCountMyWeek() {
            	if (this.deliverableTemplateCount) {
	                if (this.deliverableTemplateCount['today'] > 0){
	                    // this.showLinks();
	                    //  this.pointerEvents = "";
	                    //  this.texDecoration = "";
	                    //  this.textColor = "";
	                }else{
	                    //  this.pointerEvents = "none";
	                    //  this.texDecoration = "none";
	                    //  this.textColor = "#ccc";
	                }
	                return this.deliverableTemplateCount && this.myWeek &&
	                    this.deliverableTemplateCount['today'] != undefined &&
	                    this.deliverableTemplateCount['overdue'] != undefined &&
	                    this.deliverableTemplateCount['thisWeek'] != undefined &&
	                    this.deliverableTemplateCount['nextWeek'] != undefined &&
	                    this.deliverableTemplateCount['upcoming'] != undefined &&
	                    this.deliverableTemplateCount['noDeadline'] != undefined
                }
                return null;
            },
            deliverableTemplateCount() {
                if(this.isListView){
                    return this.totalDeliverableTemplateCountNoMasters;
                }
                return this.totalDeliverableTemplateCount;
            }
        },
        methods: {
        	...mapActions({
        	  getDeliverableTemplates (dispatch, payload) {
        	    return dispatch(this.namespace + 'getDeliverableTemplates', payload)
        	  },
        	  getCalendarData (dispatch, payload) {
        	    return dispatch(this.namespace + 'getCalendarData', payload)
        	  },
        	  fetchAllProjects (dispatch, payload) {
        	    return dispatch(this.namespace + 'fetchAllProjects', payload)
        	  },
        	  filterDeliverableTemplatesBasedOnSettings (dispatch, payload) {
        	    return dispatch(this.namespace + 'filterDeliverableTemplatesBasedOnSettings', payload)
        	  },
        	}),

            expandIcons() {
                this.showAllAddButton = true;
            },
            retractIcons() {
                this.showAllAddButton = false;
            },

            clickDeliverableTemplateIcon() {
                if (this.hasMultipleDeliverableTemplate) {
                    this.expandIcons();
                } else {
                    this.createDeliverableTemplate(this.deliverableTemplates[0]);
                }
            },

            createDeliverableTemplate(deliverableTemplate) {
                deliverableTemplate = deliverableTemplate.id;
                let that = this;
                this.$store.dispatch(this.namespace + "createNewDeliverableTemplate", { deliverableTemplate }).then(() => {
                    that.deliverableTemplate = '';
                    that.$bvModal.show("editModal");
                    that.$nextTick(() => {
                    $(".edit-deliverableTemplate-modal .deliverableTemplate-title").trigger("click");
                    });
                    that.$store.dispatch(that.namespace + "fetchDeliverableTemplates");
                });

                this.retractIcons();
            },

            // Hardcoded
            createMediaCall() {
                this.createDeliverableTemplate({
                    id: 'media_call',
                    name: "Media Call",
                })
            },
            addFilter(flag){
                // this.weekFilterOptions[flag] = !this.weekFilterOptions[flag];
            },
             overdueClick(deliverableTemplate){
                // this.addFilter(deliverableTemplate);
                this.filterQuery = this.myWeekDeliverableTemplateFilter;
                if (deliverableTemplate == '0'){
                    this.filterQuery.weekFilterOptions = null;
                }else{
                    this.filterQuery.weekFilterOptions[deliverableTemplate] =  !this.filterQuery.weekFilterOptions[deliverableTemplate];

                }
                this.$store.commit(this.namespace + "setDeliverableTemplateFilter", this.filterQuery);
                // this.$store.dispatch(this.namespace + "fetchDeliverableTemplates");

            },

             getBgColor(deliverableTemplate){
                this.filterQuery =  this.myWeekDeliverableTemplateFilter;

                    this.pointerEvents = "";
                     this.texDecoration = "";
                     this.textColor = "";



                if (typeof this.filterQuery.weekFilterOptions != 'undefined' ){
                      if(this.filterQuery.weekFilterOptions[deliverableTemplate]){
                        return "var(--text-muted-show-deliverableTemplate-count-my-week-bg)"
                    }else{
                        return ""
                    }
                }else{
                    return ""
                }

                // if(this.filterQuery.filterTopTest[deliverableTemplate]){
                //     return "#fff000"
                // }else{
                //     return "#fff"
                // }
            }
        },
        mounted() {
            document.addEventListener("pointerdown", this.retractIcons);
            this.filterQuery = this.myWeekDeliverableTemplateFilter;
            // this.filterQuery.weekFilterOptions =  this.weekFilterOptions;
            // this.$nextTick(() => {
	        //     this.$store.dispatch(this.namespace + "filterDeliverableTemplatesBasedOnSettings");
	        // });
        },
        created(){
            
        },
        updated(){
            
        },
        destroyed() {
            document.removeEventListener("pointerdown", this.retractIcons);
        },
    }
</script>
